import axios from '@axios'

/**
 * ÍNDICE
 * {@link getCorrectingReasons} - Obtener motivos de rectificación de facturas
 */

/**
 * 
 * @param {*} queryParams 
 * @returns {Promise} response
 */

export const getCorrectingReasons = function () {
    try {
        return new Promise((resolve, reject) => {
                    axios
                        .get('/correcting-reasons')
                        .then(response => resolve(response))
                        .catch(error => reject(error))
                })
    }  catch (error) {
        return error
    }
}

    

